export const VERIFICATION_CONFIG_SET_TYPE = 'VERIFICATION_CONFIG_SET_TYPE';
export const VERIFICATION_CONFIG_FETCH = 'VERIFICATION_CONFIG_FETCH';
export const VERIFICATION_CONFIG_FETCH_ERROR =
  'VERIFICATION_CONFIG_FETCH_ERROR';
export const VERIFICATION_CONFIG_FETCHING = 'VERIFICATION_CONFIG_FETCHING';
export const VERIFICATION_CONFIG_SUBMITTING = 'VERIFICATION_CONFIG_SUBMITTING';
export const VERIFICATION_CONFIG_SUBMIT = 'VERIFICATION_CONFIG_SUBMIT';
export const VERIFICATION_CONFIG_SUBMIT_ERROR =
  'VERIFICATION_CONFIG_SUBMIT_ERROR';



// WEBPACK FOOTER //
// ./src/pages/verificationconfiguration/state/configuration/types.js